import { render, staticRenderFns } from "./FormDateTimeQuestionSettings.vue?vue&type=template&id=8a42fe0c"
import script from "./FormDateTimeQuestionSettings.vue?vue&type=script&lang=js"
export * from "./FormDateTimeQuestionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports